/**
 * Actycrea: toast.js (ES6 Helper)
 * MIT
 */

import { Toast } from 'bootstrap';

const SELECTOR_TOASTS = '.toast-container';

class ToastHelper {

  constructor( ){
    this.toastNode = this._ensureContainer( );
  }

  _ensureContainer( ){
    let node = document.querySelector( SELECTOR_TOASTS );
    if( !node ){
      node = document.createElement( 'div' );
      node.className = 'toast-container';
      document.body.appendChild( node );
    }
    return node;
  }

  /**
   * Inserta HTML de toast y lo muestra.
   * @param {string} html - Marcado completo del toast.
   */
  show( html ){
    if( typeof html !== 'string' || html.trim( ) === '' ) return;

    this.toastNode.insertAdjacentHTML( 'beforeend' , html );

    const el = this.toastNode.querySelector( '.toast:last-child' );
    if( !el ) return;

    const toast = new Toast( el );
    toast.show( );

    el.addEventListener( 'hidden.bs.toast' , ( ) => el.remove( ) , { once : true } );
  }

}

export const Toasts = new ToastHelper( );
export default Toasts;
